import { observer } from 'mobx-react-lite';

import { Button } from '@/components/ui/Button';
import { YStack } from '@/components/ui/layout/layout';
import { userStore } from '@/stores/user.store';

import { SettingsSection } from '../settings-section';

import {
  useBackendChoiceSetting,
  useOpenWorkElsewhere,
} from './settings-backend.hooks';

export const BackendSettings = observer(function BackendSettings() {
  if (!userStore.isInternalUser) return null;

  return (
    <SettingsSection.Root>
      <SettingsSection.Header>
        <SettingsSection.Title>Backend</SettingsSection.Title>
      </SettingsSection.Header>
      <BackendChoiceGroup />
    </SettingsSection.Root>
  );
});

const BackendChoiceGroup = observer(function BackendChoiceGroup() {
  const setting = useBackendChoiceSetting();

  return (
    <SettingsSection.Group title="Backend choice">
      <SettingsSection.Item>
        <SettingsSection.ItemHeader>
          <SettingsSection.ItemLabel>
            Use the TypeScript backend
          </SettingsSection.ItemLabel>
          <SettingsSection.ItemDescription>
            Staff accounts use the TypeScript backend, on every device.
          </SettingsSection.ItemDescription>
        </SettingsSection.ItemHeader>
        <SettingsSection.Switch
          aria-label="Use the TypeScript backend"
          checked={setting.usesTypeScript}
          disabled
        />
      </SettingsSection.Item>
      {setting.loadFailed ? (
        <YStack className="items-start gap-3">
          <p role="alert" className="text-sm text-danger-11">
            The backend choice could not be loaded.
          </p>
          <Button variant="outline" size="sm" onClick={setting.retryLoad}>
            Try again
          </Button>
        </YStack>
      ) : null}
      {setting.servedByLine ? (
        <p className="text-xs text-foreground-muted">{setting.servedByLine}</p>
      ) : null}
      <OpenWorkElsewhereList />
    </SettingsSection.Group>
  );
});

const OpenWorkElsewhereList = observer(function OpenWorkElsewhereList() {
  const view = useOpenWorkElsewhere();
  if (!view) return null;

  return (
    <YStack
      role="region"
      aria-label={view.title}
      className="items-start gap-1 text-sm"
    >
      <p className="font-medium">{view.title}</p>
      {view.items.length > 0 ? (
        <ul className="text-foreground-muted">
          {view.items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      ) : null}
      {view.clusterNotes.map((note) => (
        <p key={note} className="text-xs text-foreground-muted">
          {note}
        </p>
      ))}
    </YStack>
  );
});
